import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Fab from "components/support/fab";
import Typography from "material-ui-next/Typography";
import { Page, If } from "components/support";
import { colors } from "assets";

import Filter from "./filter";
import DataTable from "./data-table";

export default class CompanyView extends Component {
  constructor(props) {
    super(props);
    this.router = props.transition.router;

    this.state = {
      loading: false
    };
  }

  redirectTo(target, params) {
    this.router.stateService.go(target, params, {});
  }

  setLoading = async value => {
    this.setState({ loading: value });
  };

  handleFilterChange = filtered => {
    this.setState({ filter: filtered });
  };

  render() {
    const { viewModel } = this.props;
    const { currentUser } = viewModel;

    return (
      <Page>
        <Row>
          <Col xs={12}>
            <Typography type="display1" className="pb-sm">
              Empresas
            </Typography>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Filter
              loading={this.state.loading}
              onFilter={this.handleFilterChange}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <DataTable
              redirectTo={(target, params) => this.redirectTo(target, params)}
              filter={this.state.filter}
              loading={this.state.loading}
              setLoading={this.setLoading}
            />
          </Col>
        </Row>

        <If test={currentUser.is_admin}>
          <Fab
            backgroundColor={colors.button.secondary}
            onClick={() => this.redirectTo("app.registration.company.create")}
            icon="add"
          />
        </If>
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/company/company.view.jsx